import { Injectable } from '@angular/core';
import { NgbModal }   from '@ng-bootstrap/ng-bootstrap';

import { VideoViewerComponent }    from './video-viewer.component';
import { VideoViewerOptionsModel } from './typings/video-viewer.options';

@Injectable({
  providedIn: 'root'
})
export class VideoViewerService {
  constructor (
    private modalService: NgbModal
  ) {}

  // Resolves once the viewer is closed, however it was closed.
  view ( src : string, options : VideoViewerOptionsModel = {} ) : Promise<void> {
    // Esc closes the video, as the AngularJS viewer did; the global modal config turns it off.
    const modal = this.modalService.open(VideoViewerComponent, {
      keyboard   : true,
      windowClass: options.windowClass || 'video-modal'
    });

    modal.componentInstance.src = src;

    return modal.result.then(() => undefined, () => undefined);
  }
}
